// แถบซ้ายของหน้า Setting (โครงเดียวกับหน้าแบรนด์ แต่หัวเป็น Setting แทน dropdown)
import { Link } from "react-router";
import { useSidebarStore } from "@features/navigation/model/sidebar-store";
import { IconCollapse } from "@shared/ui/icons";
import { MENU_ICONS } from "@shared/ui/menu-icons";
import { cn } from "@shared/lib/utils";
import { SETTING_MENUS, settingPath } from "../model/setting-menus";

export function SettingSidebar({ activeMenuId }: { activeMenuId: string }) {
  const collapsed = useSidebarStore((s) => s.collapsed);
  const toggleCollapsed = useSidebarStore((s) => s.toggleCollapsed);

  return (
    <aside className={cn("sidebar", collapsed && "collapsed")} id="sidebar">
      <div className="sidebar-inner">
        <div className="brand-select">
          <div className="brand-select-btn" style={{ cursor: "default" }}>
            <span
              className="mini-logo"
              style={{ background: "linear-gradient(135deg,#0866ff,#6a3df5)" }}
            >
              ⚙
            </span>
            <span className="name">Setting</span>
          </div>
        </div>
        <nav className="side-nav">
          {SETTING_MENUS.map((m) => {
            const Icon = MENU_ICONS[m.icon];
            return (
              <div
                key={m.id}
                className={cn("side-item", m.id === activeMenuId && "active")}
                data-menu={m.id}
              >
                <Link className="side-link" to={settingPath(m.id)}>
                  <span className="icon">
                    <Icon />
                  </span>
                  <span className="label">{m.label}</span>
                </Link>
              </div>
            );
          })}
        </nav>
      </div>
      <div className="sidebar-footer">
        <button type="button" className="collapse-btn" onClick={toggleCollapsed}>
          <span className="icon">
            <IconCollapse />
          </span>
          <span className="label">Collapse</span>
        </button>
      </div>
    </aside>
  );
}
